import React, { Component } from "react";

class Trainings extends Component {
  render() {
    return (
      <div>
        <div className="row" style={{marginTop:30}}>
          <div className="col-3"></div>
          <h4 className="col-3">Trainings</h4>
          <h4 className="col-3">Actual Schools</h4>
          <div className="col-3"></div>
        </div>
      </div>
    );
  }
}

export default Trainings;



// WEBPACK FOOTER //
// ./src/pages/Trainings.js